<template>
  <el-form-item :label="i18nt('designer.setting.dialogWidth')">
    <el-input type="text" v-model="optionModel.width"></el-input>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"
  import propertyMixin from "../propertyMixin"

  export default {
    name: "width-editor",
    mixins: [i18n, propertyMixin],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// width-editor.vue?1e5ad890